/* eslint-disable react/require-default-props */
import React from 'react';
import proptypes from 'prop-types';

import { extend } from '@thd-nucleus/data-sources';
import { useConfigService } from '@thd-nucleus/experience-context';

import { getItemQuantities } from '@thd-olt-component-react/product-bundle';
import { BundleMiniContent } from '../../BundleMiniContent';
import { BundleMiniPlaceholder } from '../../BundleMiniPlaceholder';
import { useDataProducts } from '../../../hooks/useDataProducts';
import { useMiniItemGate } from '../../../hooks/useMiniItemGate';
import { attachComponentQuantities } from '../../../utils/product-utils';
import { BundleProductsDataModel } from '../../../models/dataModel';

const { bool, shape, func } = proptypes;

export const BundleMiniItem = ({ bundleLoading = false, bundleData = {}, onError = () => { } }) => {
  // Config-profile overrides used for preview when no live bundle matches the case we want:
  // bundleProductsKitchen swaps which itemIds are fetched; bundleProductsDetails forces per-item quantities.
  const configBundleProductsKitchen = useConfigService('bundleProductsKitchen') || null;
  const configBundleProductsDetails = useConfigService('bundleProductsDetails') || null;

  const components = bundleData?.bundleSpecificationDetails?.components || [];
  const overrideItemIds = configBundleProductsKitchen ? configBundleProductsKitchen.split(',') : null;
  const itemIds = overrideItemIds || components.map((comp) => comp.defaultProductId);

  // Item-level products are needed for per-item MAP pricing; the bundle response alone can't express it.
  // itemQuantities lets the backend compute each item's bundle promotions in the full-bundle context.
  const { data, loading: productsLoading, error } = useDataProducts({
    itemIds,
    itemQuantities: getItemQuantities(itemIds, bundleData, configBundleProductsDetails),
    skip: itemIds.length === 0
  });

  const products = attachComponentQuantities({
    products: data?.products, components, configBundleProductsDetails
  });
  const { loading, renderMiniItem } = useMiniItemGate({
    bundleData, products, productsLoading, bundleLoading, error, onError
  });

  if (loading) {
    return <BundleMiniPlaceholder />;
  }

  if (!renderMiniItem) {
    return null;
  }

  return (
    <BundleMiniContent
      product={bundleData}
      products={products}
      removeBackgroundImage
    />
  );
};

BundleMiniItem.propTypes = {
  bundleLoading: bool,
  bundleData: shape({}),
  onError: func
};

BundleMiniItem.dataModel = extend(
  BundleProductsDataModel,
  BundleMiniContent
);